export const ActionTypes = {
  FETCH_LINE_JOB_HISTORY_OPERATION: 'services/lineJobHistoryOperation/fetch_line_job_history_operation',
  SET_LINE_JOB_HISTORY_OPERATION: 'services/lineJobHistoryOperation/set_line_job_history_operation',
  SET_LINE_JOB_HISTORY_OPERATION_LOADER_STATUS:
    'services/lineJobHistoryOperation/set_line__job_history_operation_loader_status',
  UPDATE_JOB_HISTORY_OPERATION: 'services/jobHistoryOperation/update_job_history_operation',
};

const fetchLineJobHistoryOperation = ({ lineJobHistoryOperationParams }) => ({
  lineJobHistoryOperationParams,
  type: ActionTypes.FETCH_LINE_JOB_HISTORY_OPERATION,
});

const setLineJobHistoryOperation = ({ lineJobHistoryOperationData }) => ({
  lineJobHistoryOperationData,
  type: ActionTypes.SET_LINE_JOB_HISTORY_OPERATION,
});

const updateJobHistoryOperation = ({ jobHistoryOperationObj, jobHistoryOperationParams }) => ({
  jobHistoryOperationObj,
  jobHistoryOperationParams,
  type: ActionTypes.UPDATE_JOB_HISTORY_OPERATION,
});

const setLineJobHistoryOperationLoaderStatus = ({ lineJobHistoryOperationLoader }) => ({
  lineJobHistoryOperationLoader,
  type: ActionTypes.SET_LINE_JOB_HISTORY_OPERATION_LOADER_STATUS,
});

export default {
  fetchLineJobHistoryOperation,
  setLineJobHistoryOperation,
  updateJobHistoryOperation,
  setLineJobHistoryOperationLoaderStatus,
};
